import { createSlice } from '@reduxjs/toolkit';

const mappingSlice = createSlice({
  name: 'mapping',
  initialState: {},
  reducers: {
    setBoundingBox: (state, action) => action.payload, 
    clearBoundingBox: (state) => {
      Object.keys(state).forEach(key => delete state[key]);
    }
  },
});

export const { setBoundingBox } = mappingSlice.actions;
export default mappingSlice.reducer;
